import type { ZodType } from 'zod';

/** localStorage that never throws and validates what it reads. */
export function readJSON<T>(key: string, schema: ZodType<T>): T | null {
  try {
    const raw = localStorage.getItem(key);
    if (!raw) return null;
    const parsed = schema.safeParse(JSON.parse(raw));
    if (!parsed.success) {
      console.warn(`[storage] "${key}" failed validation, resetting`, parsed.error.issues);
      localStorage.removeItem(key);
      return null;
    }
    return parsed.data;
  } catch {
    return null;
  }
}

export function writeJSON(key: string, value: unknown): void {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch {
    /* private mode / quota: ignore */
  }
}
